<template>
    <div class="swiper-slide">
        <slot></slot>
    </div>
</template>

<script>
	export default {
		name: '',
		props: {
			title: {
				type: String,
				default: ''
			}
		}
	}
</script>

<style lang="scss" scoped>
    .swiper-slide {
        width: 100%;
        height: 100%;
    }
</style>